import React from 'react';

var defaultImg = require("../../default.json");

var ContentDownLeft = React.createClass({
  render: function(){
    var img = "", show;
    if(this.props.data["details_image"] == "null" || !(this.props.data["details_image"])){
       img = "";
       show = false;
    } else{
      img = this.props.data["details_image"];
      show = true;
    }
    return(
        <div>
            {this.props.data.hasOwnProperty("description") ?
            <div className="theme__details">
              <p>{this.props.data["description"] === "" || this.props.data["description"] === "null"  ? "" : this.props.data["description"] }</p>
            </div> : null }
            { show ?
            <div data-view="toggleItemDesc">
              <div className="item-desc__details">
                 <img src={img} width="595px" height="300px" alt="Blended Theme Image" title="" className="img-responsive"/>
              </div>
            </div> : <div /> }
        </div>
    );
  }
});

export {ContentDownLeft};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/ContentDownLeft.jsx
 **/